import React, { memo } from 'react';
import { connect, useSelector } from 'react-redux';

import MenuSection from 'bento-ordering/menus/components/MenuSection';
import RuleContainer from 'bento-ordering/base/ui_components/RuleContainer';
import { getTotalCartItemQuantities } from 'bento-ordering/cart/selectors';
import shouldLazyLoadMenu from 'bento-ordering/menus/utils/shouldLazyLoadMenu';
import { useMenu } from 'bento-ordering/context/MenuContext';
import MenuSectionSkeleton from 'bento-ordering/menus/components/MenuSectionSkeleton';
import NoSearchResults from 'bento-ordering/menus/components/NoSearchResults';
import MenuPopularItems from 'bento-ordering/menus/components/MenuPopularItems';

const MenuSectionsContainer = () => {
  const { menu, isFilteringInProgress, searchTerm } = useMenu();
  const shouldLazyLoadMenuResult = useSelector(state =>
    shouldLazyLoadMenu(menu, state)
  );

  const renderMenuSections = () => {
    let content = null;
    if (menu.sections.length) {
      content = menu.sections.map((menuSection, index) => (
        <MenuSection
          key={menuSection.id}
          isFirst={index === 0}
          {...menuSection}
          shouldLazyLoadMenu={shouldLazyLoadMenuResult}
        />
      ));
    } else if (searchTerm) {
      content = (
        <>
          <NoSearchResults searchTerm={searchTerm} />
          <MenuPopularItems />
        </>
      );
    }

    return content;
  };

  return (
    <RuleContainer>
      {isFilteringInProgress ? <MenuSectionSkeleton /> : renderMenuSections()}
    </RuleContainer>
  );
};

const MemoizedMenuSectionsContainer = memo(
  MenuSectionsContainer,
  (previousProps, nextProps) => {
    const { menuId, cart, locationInventoryLoading = false } = previousProps;

    const isSameMenuId = menuId === nextProps.menuId;

    // this can affect inventory
    const isSameCartQuantity =
      getTotalCartItemQuantities(cart) ===
      getTotalCartItemQuantities(nextProps.cart);

    const isLocationInventoryStillLoading =
      !locationInventoryLoading || nextProps.locationInventoryLoading;

    // Need to update component when fulfillment_date changes for low
    // inventory items whose count_future_day_orders is set to False.
    const isSamefulfillmentDate =
      cart.fulfillment_date === nextProps.cart.fulfillment_date;

    return (
      isSameMenuId &&
      isSameCartQuantity &&
      isLocationInventoryStillLoading &&
      isSamefulfillmentDate
    );
  }
);

export default connect(state => ({
  menuId: state.menu.id,
  cart: state.cart,
  locationInventoryLoading: state.locationInventory.isLoading
}))(MemoizedMenuSectionsContainer);
